<div class="main-container">
  <img src="assets/GlobeIQ_Icon.svg" />
  <div class="message">You are not authorized to access this resource.</div>
  <div class="styled-button" [routerLink]="[home]">Go Home</div>
</div>
